import { CongressesService } from "@/client";
import type { Congress } from "@/client";
import { HttpError } from "@/types/error";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { congressesQueryKey } from "@/features/congress-select/api/use-congresses";
import { queryClient } from "@/libs/react-query";

function useDuplicateCongress(
  congressId: string,
  mutationOptions?: UseMutationOptions<Congress, HttpError, void>,
) {
  return useMutation({
    mutationFn: () =>
      CongressesService.duplicateCongress({
        congressId,
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: congressesQueryKey });
    },
    ...mutationOptions,
  });
}

export { useDuplicateCongress };
